module.exports = __webpack_public_path__ + "static/img/66053J_6_R_20200731_LC.76f56c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/66053J_6_R_20200731_LC.png
// module id = ca9Y
// module chunks = 0